import TableText from "@/components/table/TableText";
import _ from 'lodash';
import moment from "moment";
import React from "react";
import { sum, calculation, numConvert } from '@/method';

const totalIndex = [];
const percentIndex = [54, 55, 56, 57, 58];
const nameList = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
const keys = [
    { name: "RETAIL", key: "retail" },
    { name: "WHOLESALE", key: "wholesale" },
    { name: "CORPORATE NEGOTIATE", key: "coprorate" },
    { name: "GOVERNMENT / DIPLOMAT", key: "government" },
    { name: "DISCOUNT & AWARDS", key: "discount" },
    { name: "TOTAL TRANSIENT", key: "transient" },
    { name: "TOTAL BUSINESS GROUP", key: "business" },
    { name: "TOTAL LEISURE GROUP", key: "leisure" },
    { name: "TOTAL GROUPS", key: "groups" },
    { name: "CONTRACTS", key: "contracts" },
    { name: "OTHERS", key: "others" },
    { name: "GRAND TOTAL", key: "total" },
];

export const compute = (data, { budget, last, actual, month }) => {
    //    填充数据
    const corresponding = {
        retail: 3,
        wholesale: 6,
        coprorate: 10,
        government: 11,
        discount: 14,
        transient: 15,
        business: 18,
        leisure: 22,
        groups: 23,
        contracts: 27,
        others: 33,
        total: 34,
    };
    Object.entries(corresponding).forEach(([key, index]) => {
        nameList.forEach((name, i) => {
            // 预算 
            data[i * 3 + 1][`${key}_rn`] = _.get(budget, `${index}.${name}_rn`, 0);
            data[i * 3 + 1][`${key}_adr`] = _.get(budget, `${index}.${name}_adr`, 0);
            data[i * 3 + 1][`${key}_rev`] = _.get(budget, `${index}.${name}_rev`, 0);
            // 实际  
            // if (i < ~~month) {
            data[i * 3][`${key}_rn`] = _.get(actual, `${index}.${name}_rn`, 0);
            data[i * 3][`${key}_adr`] = _.get(actual, `${index}.${name}_adr`, 0);
            data[i * 3][`${key}_rev`] = _.get(actual, `${index}.${name}_rev`, 0);
            // }

            // 去年
            data[i * 3 + 2][`${key}_rn`] = _.get(last, `${index}.${name}_rn`, 0);
            data[i * 3 + 2][`${key}_adr`] = _.get(last, `${index}.${name}_adr`, 0);
            data[i * 3 + 2][`${key}_rev`] = _.get(last, `${index}.${name}_rev`, 0);
        });
    });

    // Q1 - Q4
    keys.forEach(({ key }) => {
        [12, 13, 14, 15].forEach((index, i) => {
            const INDEX = ~~(index * 3);
            data[INDEX][`${key}_rn`] = sum([
                data[~~((i * 2 + index - 12) * 3)][`${key}_rn`],
                data[~~((i * 2 + index - 11) * 3)][`${key}_rn`],
                data[~~((i * 2 + index - 10) * 3)][`${key}_rn`],
            ]);
            data[INDEX + 1][`${key}_rn`] = sum([
                data[~~((i * 2 + index - 12) * 3) + 1][`${key}_rn`],
                data[~~((i * 2 + index - 11) * 3) + 1][`${key}_rn`],
                data[~~((i * 2 + index - 10) * 3) + 1][`${key}_rn`],
            ]);
            data[INDEX + 2][`${key}_rn`] = sum([
                data[~~((i * 2 + index - 12) * 3) + 2][`${key}_rn`],
                data[~~((i * 2 + index - 11) * 3) + 2][`${key}_rn`],
                data[~~((i * 2 + index - 10) * 3) + 2][`${key}_rn`],
            ]);

            data[INDEX][`${key}_rev`] = sum([
                data[~~((i * 2 + index - 12) * 3)][`${key}_rev`],
                data[~~((i * 2 + index - 11) * 3)][`${key}_rev`],
                data[~~((i * 2 + index - 10) * 3)][`${key}_rev`],
            ]);
            data[INDEX + 1][`${key}_rev`] = sum([
                data[~~((i * 2 + index - 12) * 3) + 1][`${key}_rev`],
                data[~~((i * 2 + index - 11) * 3) + 1][`${key}_rev`],
                data[~~((i * 2 + index - 10) * 3) + 1][`${key}_rev`],
            ]);
            data[INDEX + 2][`${key}_rev`] = sum([
                data[~~((i * 2 + index - 12) * 3) + 2][`${key}_rev`],
                data[~~((i * 2 + index - 11) * 3) + 2][`${key}_rev`],
                data[~~((i * 2 + index - 10) * 3) + 2][`${key}_rev`],
            ]);

            data[INDEX][`${key}_adr`] = calculation(sum([
                data[~~((i * 2 + index - 12) * 3)][`${key}_rev`],
                data[~~((i * 2 + index - 11) * 3)][`${key}_rev`],
                data[~~((i * 2 + index - 10) * 3)][`${key}_rev`],
            ]), sum([
                data[~~((i * 2 + index - 12) * 3)][`${key}_rn`],
                data[~~((i * 2 + index - 11) * 3)][`${key}_rn`],
                data[~~((i * 2 + index - 10) * 3)][`${key}_rn`],
            ]), 2);
            data[INDEX + 1][`${key}_adr`] = calculation(sum([
                data[~~((i * 2 + index - 12) * 3) + 1][`${key}_rev`],
                data[~~((i * 2 + index - 11) * 3) + 1][`${key}_rev`],
                data[~~((i * 2 + index - 10) * 3) + 1][`${key}_rev`],
            ]), sum([
                data[~~((i * 2 + index - 12) * 3) + 1][`${key}_rn`],
                data[~~((i * 2 + index - 11) * 3) + 1][`${key}_rn`],
                data[~~((i * 2 + index - 10) * 3) + 1][`${key}_rn`],
            ]), 2);
            data[INDEX + 2][`${key}_adr`] = calculation(sum([
                data[~~((i * 2 + index - 12) * 3) + 2][`${key}_rev`],
                data[~~((i * 2 + index - 11) * 3) + 2][`${key}_rev`],
                data[~~((i * 2 + index - 10) * 3) + 2][`${key}_rev`],
            ]), sum([
                data[~~((i * 2 + index - 12) * 3) + 2][`${key}_rn`],
                data[~~((i * 2 + index - 11) * 3) + 2][`${key}_rn`],
                data[~~((i * 2 + index - 10) * 3) + 2][`${key}_rn`],
            ]), 2);
        });
    });

    // YTD
    keys.forEach(({ key }) => {
        const RN = `${key}_rn`;
        const ARR = `${key}_adr`;
        const name = `${key}_rev`;
        data[48][RN] = data.reduce((a, b, i) => {
            if (i < 48 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 0)) {
                a += numConvert(b[RN]);
            }
            return a
        }, 0).toFixed(2);
        data[49][RN] = data.reduce((a, b, i) => {
            if (i < 48 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 1)) {
                a += numConvert(b[RN]);
            }
            return a
        }, 0).toFixed(2);
        data[50][RN] = data.reduce((a, b, i) => {
            if (i < 48 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 2)) {
                a += numConvert(b[RN]);
            }
            return a
        }, 0).toFixed(2);
        data[48][name] = data.reduce((a, b, i) => {
            if (i < 48 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 0)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[49][name] = data.reduce((a, b, i) => {
            if (i < 48 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 1)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[50][name] = data.reduce((a, b, i) => {
            if (i < 48 && Math.ceil((i + 1) / 3) <= month && (i % 3 == 2)) {
                a += numConvert(b[name]);
            }
            return a
        }, 0).toFixed(2);
        data[48][ARR] = data[48][RN] == 0 ? 0 : (data[48][name] / data[48][RN]).toFixed(2);
        data[49][ARR] = data[49][RN] == 0 ? 0 : (data[49][name] / data[49][RN]).toFixed(2);
        data[50][ARR] = data[50][RN] == 0 ? 0 : (data[50][name] / data[50][RN]).toFixed(2);

        [RN, name].forEach(newName => {
            data[51][newName] = data.reduce((a, b, i) => {
                if (i < 36 && i % 3 == 0) {
                    a += numConvert(b[newName]);
                }
                return a
            }, 0).toFixed(2);
            data[52][newName] = data.reduce((a, b, i) => {
                if (i < 36 && i % 3 == 1) {
                    a += numConvert(b[newName]);
                }
                return a
            }, 0).toFixed(2);
            data[53][newName] = data.reduce((a, b, i) => {
                if (i < 36 && i % 3 == 2) {
                    a += numConvert(b[newName]);
                }
                return a
            }, 0).toFixed(2);
        });
        [51, 52, 53].forEach(index => {
            data[index][ARR] = data[index][RN] == 0 ? 0 : (data[index][name] / data[index][RN]).toFixed(2)
        });
    });

    // % to Budget --- Year End Mix %
    keys.forEach(({ key }) => {
        const RN = `${key}_rn`;
        const ARR = `${key}_adr`;
        const REV = `${key}_rev`;
        [RN, ARR, REV].forEach(name => {
            data[54][name] = data[49][name] == 0 ? 0 : ((data[48][name] - data[49][name]) / data[49][name]).toFixed(4);
            data[55][name] = data[52][name] == 0 ? 0 : ((data[51][name] - data[52][name]) / data[52][name]).toFixed(4);
            data[56][name] = data[50][name] == 0 ? 0 : ((data[48][name] - data[50][name]) / data[50][name]).toFixed(4);

            if (name.includes("_rn") || name.includes("_rev")) {
                data[57][name] = calculation(data[48][name], data[51][name], 4);
                data[58][name] = calculation(data[49][name], data[52][name], 4);
            }
        });
    });
    return data;
}

export const columns = (onChange, date, print) => {
    const sqlName = "_4new_4_3_2";
    return [
        {
            title: 'key',
            dataIndex: 'sort',
            key: 'sort',
            align: "center",
            fixed: print ? false : "left",
            width: 50,
            render: t => {
                return t
            }
        },
        {
            title: 'MONTH',
            dataIndex: 'month_name',
            key: 'month_name',
            align: "center",
            fixed: print ? false : "left",
            width: 100,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "month_name",
                    onChange,
                    totalIndex,
                    compared: {
                        title: ['MONTH'],
                        record,
                        sqlName
                    }
                };
                if (index < 54) {
                    if (index % 3 === 0) return {
                        props: {
                            rowSpan: 3,
                        },
                        children: <TableText data={props} />
                    }
                    return { props: { rowSpan: 0 } }
                }

                if ([54, 55, 57, 58].includes(index)) {
                    if (index == 54 || index == 57) return {
                        props: {
                            rowSpan: 2,
                        },
                        children: <TableText data={props} />
                    }
                    return { props: { rowSpan: 0 } }
                }
                return <TableText data={props} />
            }
        }, {
            title: 'YEAR',
            dataIndex: 'year_name',
            key: 'year_name',
            align: "center",
            fixed: print ? false : "left",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "year_name",
                    onChange,
                    totalIndex,
                    compared: {
                        title: ['YEAR'],
                        record,
                        sqlName
                    }
                };
                return <TableText data={props} />
            }
        },
        ...keys.map((item, i) => {
            return {
                title: item.name,
                align: "center",
                width: 450,
                children: [{
                    title: "R/Nts",
                    dataIndex: `${item.key}_rn`,
                    key: `${item.key}_rn`,
                    width: 150,
                    align: "center",
                    render: (text, record, index) => {
                        const title = [item.name, 'R/Nts'];
                        const props = {
                            text,
                            index,
                            type: percentIndex.includes(index) ? 'percent' : "number",
                            name: `${item.key}_rn`,
                            onChange,
                            totalIndex,
                        };
                        props.compared = {
                            title,
                            record,
                            sqlName
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: "ADR",
                    dataIndex: `${item.key}_adr`,
                    key: `${item.key}_adr`,
                    width: 150,
                    align: "center",
                    render: (text, record, index) => {
                        const title = [item.name, 'ADR'];
                        const props = {
                            text,
                            index,
                            type: [57, 58].includes(index) ? '' : percentIndex.includes(index) ? 'percent' : "number",
                            name: `${item.key}_adr`,
                            onChange,
                            totalIndex,
                        };
                        props.compared = {
                            title,
                            record,
                            sqlName
                        };
                        return <TableText data={props} />
                    }
                }, {
                    title: "Revenue",
                    dataIndex: `${item.key}_rev`,
                    key: `${item.key}_rev`,
                    width: 150,
                    align: "center",
                    render: (text, record, index) => {
                        const title = [item.name, 'Revenue'];
                        const props = {
                            text,
                            index,
                            type: percentIndex.includes(index) ? 'percent' : "number",
                            name: `${item.key}_rev`,
                            onChange,
                            totalIndex,
                        };
                        props.compared = {
                            title,
                            record,
                            sqlName
                        };
                        return <TableText data={props} />
                    }
                }]

            }
        })
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4new/4.3/4.3.2/compute.js